<template>
  <div class="zl-page flex_default_center">
    <div class="zl-content flex">
      <div class="zl-box flex_column_align_center">
        <div class="all-car-box">
          <div>
            <div
              class="zl-icon flex_default_center"
              @click="handleAllCar"
              style="cursor: pointer"
            >
              <div>
                <p>{{ $t("claimantKd.zcsp") }}</p>
                <span>Vehicle claim</span>
              </div>
              <img src="../../assets/image/vehicleIcon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="zl-box flex_column_align_center">
        <div @click="toPage()" style="cursor: pointer" class="all-car-box">
          <div class="zl-icon flex_default_center">
            <div>
              <p>{{ $t("claimantKd.kdsp") }}</p>
              <span>KD claim</span>
            </div>
            <img src="../../assets/image/KD.png" alt="" class="box_img" />
          </div>
        </div>
      </div>
      <div class="zl-box flex_column_align_center">
        <div class="all-car-box">
          <div>
            <div
              class="zl-icon flex_default_center"
              @click="toActivityPage()"
              style="cursor: pointer"
            >
              <div>
                <p>{{ $t("claimantActivity.hdsp") }}</p>
                <span>Activity claim</span>
              </div>
              <img
                src="../../assets/image/activeClaim.png"
                alt=""
                class="box_img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showCarType: false,
    };
  },
  methods: {
    toPage() {
      this.$router.push("/kdClaimant");
    },
    toActivityPage() {
      this.$router.push("/activityClaimant");
    },
    handleAllCar() {
      this.$router.push("/claimant");
    },
  },
};
</script>
<style lang="scss" scoped>
.zl-page {
  // padding-top: 100px;
  .zl-content {
    width: 95%;
    margin-top: -1.4%;
  }
  .zl-icon {
    background: rgb(249, 252, 255);
    box-sizing: border-box;
    max-width: 400px;
    width: 95%;
    height: 270px;
    border: 1px solid rgba(215, 233, 255, 1);
    border-radius: 15px;
    box-shadow: rgba(247, 247, 247, 1) 0px 1px 2px 0px;
    position: relative;
    display: block;
    > div {
      display: block;
      padding: 10px 15px;
    }
    img {
      width: 50%;
      position: absolute;
      right: 25px;
      bottom: 30px;
    }
    .box_img {
      right: 0px;
    }
  }
  .zl-box {
    width: 33.33%;
    color: #000;
    p {
      font-size: 20px;
      font-weight: bold;
      word-break: break-word;
      margin-bottom: 5px;
    }
    span {
      display: block;
      font-size: 18px;
      color: rgb(27, 82, 148);
      word-break: break-word;
    }
    .all-car-box {
      position: relative;
      width: 90%;
      max-width: 400px;
    }
    .car-type {
      position: absolute;
      top: 0;
      left: min(calc(95% + 8px), 408px);
      height: 250px;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: max-content;
      z-index: 99;
      > div {
        padding: 10px 20px;
        display: flex;
        align-items: center;
        background: #fff;
        box-sizing: border-box;
        // width: 100%;
        height: 120px;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 4px 0px;
      }
      p {
        line-height: 30px;
        word-break: break-word;
      }
      span {
        color: #000;
        word-break: break-word;
      }
    }
  }
}
</style>

<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
